import { getCompetitionPrizesEndpoint } from "@/features/predictions/config/predictionsApiPath";
import { toLot } from "@/features/predictions/services/mappers";
import type { ApiLot, Lot } from "@/features/predictions/types/lot.type";
import { fetcher } from "@/shared/lib/fetcher.client";

export const lotsService = {
  async getCompetitionLots(competitionId: string): Promise<Lot[]> {
    const response = await fetcher.get<{ prizes: ApiLot[] }>(
      getCompetitionPrizesEndpoint(competitionId),
    );
    return response.data.prizes.map(toLot);
  },
};
